<template>
  <Menu>
    <template #heading>
      <h1>Search</h1>
    </template>
    <template #content>
      <div class="search-input__wrapper container">
        <SearchInput />
      </div>
      <Search />
    </template>
  </Menu>
</template>

<script>
import Menu from "@/components/Menu.vue";
import Search from "@/components/navigation/Search.vue";
import SearchInput from "@/components/SearchInput.vue";

export default {
  name: "SearchPage",
  components: {
    Menu,
    SearchInput,
    Search,
  },
};
</script>

<style lang="scss" scoped>
.menu {
  border: none;
}

.search-input {
  margin-bottom: 20px;
  border-bottom: 1px solid $color-grey;
}
</style>
